import { bool } from "prop-types"
import { MenuLink } from "@reach/menu-button"

const ManageCategoriesButton = ({ isAdmin = false }) => {
  return (
    isAdmin && (
      <MenuLink className="dropdown-menu-item" data-modal-url="/categories/edit">
        Manage categories
      </MenuLink>
    )
  )
}

ManageCategoriesButton.propTypes = {
  isAdmin: bool
}

export default ManageCategoriesButton
